import { oneOf } from 'prop-types';
import styled from 'styled-components';
import bgSrc from '../../assets/images/bg-missing-preview.jpg';
import bgSrcMill from '../../assets/images/bg-missing-preview-mill.jpg';
import { ReactComponent as ImageSvg } from '../../assets/icons/photo-video.svg';
import { PROJECT_TYPES } from '../../config';

const ImageIcon = styled(ImageSvg)`
    width: 30px;
    height: 30px;
    fill: ${({theme}) => theme.colors.bg_gray_light};
    margin-bottom: 16px;
`;

const Wrapper = styled.div`
    height: 150px;
    background-color: #f9f9f9;
    background-image: url(${({type}) => type === 'mill' ? bgSrcMill : bgSrc});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${({theme}) => theme.colors.bg_gray_light};
`;

function MissingPreview({ type }) {
  return (
    <Wrapper type={type}>
      <ImageIcon />
      <span>No preview available</span>
    </Wrapper>
  );
}

MissingPreview.propTypes = {
  type: oneOf([...PROJECT_TYPES, 'forestRGB', 'forestMulti']).isRequired,
}

export default MissingPreview;